import React from 'react';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';

export default function CnpjInput({ value, onChange, loading }) {
  return (
    <InputMask
      mask="99.999.999/9999-99"
      value={value}
      onChange={onChange}
      disabled={loading}
    >
      {() => (
        <TextField
          sx={{ width: '40%' }}
          disabled={loading}
          size="small"
          id="cnpj"
          name="cnpj"
          label="CNPJ"
          variant="outlined"
        />
      )}
    </InputMask>
  );
}
